<span class="icon-left {{ statusIco }} status-ico"></span>
<span class="status-str" [class.is-active]="isActive" [innerHTML]="statusStr | highlight: search"></span>
